import { slicedToArray as _slicedToArray, objectSpread2 as _objectSpread2, defineProperty as _defineProperty } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { useState, useEffect } from 'react';
import { isValidGuardAccessInput } from '../../services/utilities/validation.js';

var useGuardDirectionsUtils = function useGuardDirectionsUtils(guardDirections, waterValveDirections) {
  var initialInputs = {
    directions: guardDirections,
    waterLocation: waterValveDirections
  };
  var _useState = useState(initialInputs),
    _useState2 = _slicedToArray(_useState, 2),
    inputFields = _useState2[0],
    setInputFields = _useState2[1];
  useEffect(function () {
    initialInputs.directions = guardDirections;
    initialInputs.waterLocation = waterValveDirections;
    setInputFields({
      directions: guardDirections,
      waterLocation: waterValveDirections
    });
  }, [guardDirections, waterValveDirections]);
  var noChange = inputFields.directions === guardDirections && inputFields.waterLocation === waterValveDirections;
  var _useState3 = useState({
      directions: false,
      waterLocation: false
    }),
    _useState4 = _slicedToArray(_useState3, 2),
    errors = _useState4[0],
    setErrors = _useState4[1];
  var initialErrors = {
    directions: false,
    waterLocation: false
  };
  var isValid = function isValid(text) {
    return !isValidGuardAccessInput(text);
  };
  var onFieldChange = function onFieldChange(event) {
    var _event$target = event.target,
      value = _event$target.value,
      name = _event$target.name;
    setInputFields(_objectSpread2(_objectSpread2({}, inputFields), {}, _defineProperty({}, name, value)));
    setErrors(_objectSpread2(_objectSpread2({}, errors), {}, _defineProperty({}, name, isValid(value))));
  };
  return {
    inputFields: inputFields,
    errors: errors,
    onFieldChange: onFieldChange,
    initialInputs: initialInputs,
    initialErrors: initialErrors,
    setInputFields: setInputFields,
    setErrors: setErrors,
    noChange: noChange
  };
};

export { useGuardDirectionsUtils };
